import {atom, useAtom} from 'jotai';
import {atomFamily, atomWithDefault} from 'jotai/utils';
import {getUserData, setUserData} from '../../Services/common';
import {Dispatch} from 'react';

const serverAtom = atomFamily((key: string) => {
    const innerAtom = atomWithDefault(async () => getUserData(key));

    return atom(
        async get => get(innerAtom),
        async (get, set, data: any) => {
            set(innerAtom, data);
            await setUserData(key, data);
        },
    );
});

export function useServerStorage<T>(key: string, initialData: T) {
    const [data, setData] = useAtom(serverAtom(key));
    return [data || initialData, setData] as [T, Dispatch<T>];
}
